import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_4436_47482)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.37111 0.5H7.91636C10.0814 0.5 11.8627 2.28131 11.8627 4.4463C11.8627 4.53635 11.8602 4.62723 11.8534 4.71725C11.8602 4.81149 11.8635 4.90656 11.8635 5.0008C11.8635 6.09832 11.3944 7.09662 10.6495 7.8128C11.0624 7.99482 11.4307 8.21482 11.7597 8.46431C13.9626 10.1354 14.3909 13.2512 14.3909 15.6586V16.5H0.927979V15.6586C0.927979 13.2512 1.31924 10.1354 3.52631 8.46348C3.85112 8.21791 4.21506 8.00077 4.62347 7.82032C3.88523 7.10291 3.42398 6.10165 3.42398 5.0008C3.42398 4.90656 3.42734 4.81149 3.43409 4.71725C3.42734 4.62723 3.42481 4.53635 3.42481 4.4463C3.42481 2.28131 5.20612 0.5 7.37111 0.5ZM7.97468 7.24925C7.87127 7.24593 7.7662 7.24425 7.65943 7.24425C7.51815 7.24425 7.37983 7.24713 7.24443 7.25278C6.06044 7.19089 5.10683 6.19918 5.10683 5.0008C5.10683 4.93264 5.10935 4.86365 5.11611 4.79549L5.12283 4.72061L5.11611 4.6449C5.11022 4.57926 5.10769 4.51277 5.10769 4.4463C5.10769 3.20436 6.12916 2.18286 7.37111 2.18286H7.91636C9.15832 2.18286 10.1798 3.20436 10.1798 4.4463C10.1798 4.51277 10.1773 4.57926 10.1714 4.6449L10.1647 4.72061L10.1714 4.79549C10.1782 4.86365 10.1807 4.93264 10.1807 5.0008C10.1807 6.21228 9.17739 7.2051 7.97468 7.24925ZM7.24976 8.93712C6.0826 8.99555 5.20077 9.30695 4.54276 9.80556C3.01136 10.965 2.68489 13.0283 2.62346 14.8171H12.6929C12.6247 13.0274 12.2713 10.965 10.7424 9.80473C10.0688 9.29406 9.16463 8.9788 7.96793 8.93291C7.94239 8.93341 7.91679 8.93366 7.89115 8.93366C7.84403 8.93366 7.73527 8.93493 7.62651 8.93619C7.51775 8.93746 7.40899 8.93872 7.36187 8.93872C7.32438 8.93872 7.28701 8.93818 7.24976 8.93712Z"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4436_47482",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(0 0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgProfile);
export default ForwardRef;
